<template>
  <v-dialog v-model="isActive" content-class="schedule-dialog-compromise" fullscreen hide-overlay scrollable persistent>
    <v-card>
      <div>
        <v-card-title class="px-4" style="color: rgba(0, 0, 0, 0.6) !important">
          {{ titlePrefix }} COMPROMISSO
          <div class="close">
            <v-icon @click="closeDialog()" color="white">mdi-close</v-icon>
          </div>
        </v-card-title>
        <v-divider></v-divider>
        <div>
          <v-stepper v-model="stepper" elevation="0" vertical>
            <v-stepper-step @click="stepper = 1" :complete="stepper > 1" step="1">
              Responsável
              <small>{{ computedSelectedResponsiblesNames ?? '-' }}</small>
            </v-stepper-step>

            <v-stepper-content step="1">
              <v-row>
                <v-col cols="12" class="pr-0">
                  <div
                    class="select-responsible"
                    @click="toggleResponsible(responsible.id)"
                    v-for="responsible in responsibles.list"
                    :key="responsible.id"
                  >
                    <div class="sr-check">
                      <v-checkbox
                        v-model="responsible.selected"
                        class="ma-0 pa-0"
                        hide-details
                        @click="toggleResponsible(responsible.id)"
                      ></v-checkbox>
                    </div>
                    <div class="sr-title">
                      {{ responsible.name }}
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-btn @click="stepper = 2" class="mt-2" color="primary"> Próximo </v-btn>
            </v-stepper-content>

            <v-stepper-step @click="stepper = 2" :complete="stepper > 2" step="2">
              Data do compromisso
              <small v-if="computedDateFormatted">{{ computedDateFormatted }}</small>
            </v-stepper-step>

            <v-stepper-content step="2">
              <v-row>
                <v-col cols="12">
                  <v-date-picker v-model="date" locale="pt-br" color="#48B38B" style="background-color: #dbdbdb" full-width></v-date-picker>
                </v-col>
              </v-row>
              <v-btn class="mt-3" color="primary" @click="stepper = 3"> Próximo </v-btn>
              <v-btn @click="stepper = 1" color="#eee" class="ml-3 mt-3"> Voltar </v-btn>
            </v-stepper-content>

            <v-stepper-step @click="stepper = 3" :complete="stepper > 3" step="3">
              Hora do compromisso
              <small>{{ select_hours.selected_hour }}:{{ select_hours.selected_minute }}</small>
            </v-stepper-step>

            <v-stepper-content step="3">
              <v-row>
                <v-col cols="6">
                  <v-select filled hide-details :items="select_hours.hours" label="Hora" v-model="select_hours.selected_hour"></v-select>
                </v-col>
                <v-col cols="6">
                  <v-select filled hide-details :items="select_hours.minutes" label="Minutos" v-model="select_hours.selected_minute"></v-select>
                </v-col>
              </v-row>
              <v-btn class="mt-5" color="primary" @click="stepper = 4"> Próximo </v-btn>
              <v-btn @click="stepper = 2" color="#eee" class="ml-3 mt-5"> Voltar </v-btn>
            </v-stepper-content>

            <v-stepper-step @click="stepper = 4" :complete="stepper > 4" step="4">
              Informações
              <small v-if="details.title">{{ details.title }}</small>
            </v-stepper-step>

            <v-stepper-content step="4">
              <v-btn @click="isModalManageClientOpen = true" block outlined color="primary"> Selecionar cliente </v-btn>
              <div v-if="selected_client" class="selected-client">
                {{ selected_client.name }}
                <v-icon @click="unselectClient()" color="red">mdi-close</v-icon>
              </div>
              <div style="width: -webkit-fill-available; text-align: center; padding: 6px 0px">
                <span style="background-color: #fff; padding: 0px 10px">ou</span>
                <div style="margin-bottom: 10px; border-top: 1px solid #b9b9b9; margin-top: -11px"></div>
              </div>
              <v-text-field
                v-model="details.title"
                label="Titulo do compromisso"
                autocomplete="one-time-code"
                class="mt-1 mb-4"
                clearable
                hide-details
                outlined
                dense
              ></v-text-field>
              <v-btn color="primary" @click="stepper = 5"> Próximo </v-btn>
              <v-btn @click="stepper = 3" color="#eee" class="ml-3"> Voltar </v-btn>
            </v-stepper-content>

            <v-stepper-step @click="stepper = 5" :complete="stepper > 5" step="5">
              Placa do veículo
              <small v-if="vehicle.plate">{{ vehicle.plate }} {{ vehicle.details ? ' / ' + vehicle.details.description : '' }}</small>
            </v-stepper-step>

            <v-stepper-content step="5">
              <v-text-field
                v-model="vehicle.plate"
                @keyup="uppercaseVehiclePlate"
                :disabled="vehicle.loading_details"
                label="Placa do veículo"
                class="mt-2 mb-4"
                hide-details=""
                clearable
                outlined
                dense
                maxlength="7"
              ></v-text-field>
              <div v-if="vehicle.details" class="vehicle-card mb-4">
                <div class="vehicle-card-title">
                  {{ vehicleBrandName }} {{ vehicle.details.description }}
                </div>

                <div class="vehicle-card-plate">
                  <img v-if="vehicle.details.vehicle_plate_photo_url" :src="vehicle.details.vehicle_plate_photo_url" alt="Placa" />
                  <span v-else>{{ vehicle.details.vehicle_plate || vehicle.plate }}</span>
                </div>

                <div class="vehicle-card-row vehicle-card-brand-row">
                  <img
                    v-if="vehicle.details.vehicle_brand && vehicle.details.vehicle_brand.logo_url"
                    :src="vehicle.details.vehicle_brand.logo_url"
                    class="vehicle-card-brand-logo"
                  />
                  <b>{{ vehicle.details.description }}</b>
                </div>

                <div class="vehicle-card-row">
                  <div class="vehicle-card-cell">
                    ANO: <b>{{ vehicle.details.year }}</b>
                  </div>
                  <div class="vehicle-card-cell">
                    MODELO: <b>{{ vehicle.details.year_model }}</b>
                  </div>
                </div>

                <div class="vehicle-card-row">
                  <div class="vehicle-card-cell">
                    COR:<br />
                    <b>{{ vehicle.details.color ? vehicle.details.color.toUpperCase() : '-' }}</b>
                  </div>
                  <div class="vehicle-card-cell">
                    COMBUSTÍVEL:<br />
                    <b>{{ vehicle.details.fuel ? vehicle.details.fuel.toUpperCase() : '-' }}</b>
                  </div>
                </div>

                <div class="vehicle-card-row">
                  <div class="vehicle-card-cell">
                    CILINDRADA:<br />
                    <b>{{ vehicle.details.engine_cc || '-' }}</b>
                  </div>
                  <div class="vehicle-card-cell">
                    POTÊNCIA:<br />
                    <b>{{ vehicle.details.engine_cv || '-' }}</b>
                  </div>
                </div>

                <div class="vehicle-card-row vehicle-card-row-full" style="display: flex; justify-content: center; align-items: center">
                  IMPORTADO:
                  <b style="margin-left: 4px">{{ vehicle.details.imported == 0 ? 'NÃO' : 'SIM' }}</b>
                </div>

                <div class="vehicle-card-row vehicle-card-row-full" style="display: flex; justify-content: center; align-items: center">
                  CHASSI:
                  <b style="margin-left: 4px">{{ vehicle.details.chassi || '-' }}</b>
                </div>
              </div>
              <v-btn
                v-if="!vehicle.requested_details && vehicle.plate && vehicle.plate.length !== 0"
                :disabled="vehicle.plate && vehicle.plate.length == 7 ? false : true"
                color="primary"
                @click="extractVehicleDetails(vehicle.plate)"
              >
                Buscar
              </v-btn>
              <v-btn v-else @click="stepper = 6" :loading="vehicle.loading_details" color="primary"> Próximo </v-btn>
              <v-btn @click="stepper = 4" :disabled="vehicle.loading_details" color="#eee" class="ml-3"> Voltar </v-btn>
            </v-stepper-content>

            <v-stepper-step @click="stepper = 6" :complete="stepper > 6" step="6"> Observações </v-stepper-step>

            <v-stepper-content step="6">
              <v-select v-model="details.priority" :items="priorities" class="mb-4 mt-1" hide-details outlined label="Prioridade"></v-select>
              <v-select v-model="details.status" :items="status" class="mb-4 mt-1" hide-details outlined label="Status"></v-select>
              <v-textarea v-model="details.observation" class="mb-4 mt-1" label="Observação" rows="3" outlined hide-details></v-textarea>
              <v-btn color="primary" @click="saveSchedule"> Salvar </v-btn>
              <v-btn @click="stepper = 5" color="#eee" class="ml-3"> Voltar </v-btn>
            </v-stepper-content>
          </v-stepper>
        </div>
      </div>
    </v-card>

    <ModalManageClient v-if="isModalManageClientOpen" :isActive="isModalManageClientOpen" @close="closeModalManageClient" />
  </v-dialog>
</template>

<script>
import SchedulingService from '@/services/api/scheduling';
import ModalManageClient from '@/components/ServiceOrder/Dialogs/ModalManageClient';

const currentDate = new Date();

export default {
  name: 'ModalManageCompromise',
  emits: ['close', 'save', 'edit'],
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    ModalManageClient
  },
  data: (vm) => ({
    compromise: null,
    isModalManageClientOpen: false,
    loading: false,
    modal_date: false,
    modal_hours: false,
    stepper: 1,
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10)),
    responsibles: {
      list: []
    },
    select_hours: {
      selected_hour: currentDate.getHours().toString().padStart(2, '0'),
      selected_minute: currentDate.getMinutes().toString().padStart(2, '0'),
      hours: Array.from({ length: 24 }, (_, i) => (i < 10 ? '0' + i : '' + i)),
      minutes: Array.from({ length: 60 }, (_, i) => (i < 10 ? '0' + i : '' + i))
    },
    selected_client: null,
    details: {
      title: null,
      observation: null,
      priority: 'little_urgent',
      status: 'created'
    },
    vehicle: {
      plate: null,
      details: null,
      requested_details: false,
      loading_details: false
    },
    priorities: [
      { value: 'little_urgent', text: 'Pouco urgente' },
      { value: 'priority', text: 'Prioritária' },
      { value: 'important', text: 'Importante' },
      { value: 'critical', text: 'Crítico' }
    ],
    status: [
      { value: 'confirmed', text: 'Confirmado' },
      { value: 'canceled', text: 'Cancelado' },
      { value: 'waiting_confirm', text: 'Aguardando confirmação' },
      { value: 'created', text: 'Criado' }
    ]
  }),
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    computedSelectedResponsibles() {
      return this.responsibles.list.filter((person) => person.selected);
    },
    computedSelectedResponsiblesNames() {
      return this.responsibles.list
        .filter((person) => person.selected)
        .map((person) => person.name.split(' ')[0])
        .join(' / ');
    },
    vehicleBrandName() {
      if (!this.vehicle.details) return '';
      if (this.vehicle.details.vehicle_brand && this.vehicle.details.vehicle_brand.description) {
        return this.vehicle.details.vehicle_brand.description.toUpperCase();
      }
      return this.vehicle.details.brand || '';
    },
    isNew() {
      return !this.data.id;
    },
    titlePrefix() {
      return this.isNew ? 'NOVO' : 'EDITAR';
    }
  },
  created() {
    this.getOrganizationUsers();

    this.$store.dispatch('ClientClassification/getClientClassifications');
  },
  methods: {
    getOrganizationUsers() {
      const self = this;
      self.loading = true;
      self.$http
        .get('/web/users/organization?page=1&size=100')
        .then((response) => {
          self.responsibles.list = response.data.rows.map((user) => ({
            ...user,
            selected: false
          }));
          self.loading = false;
        })
        .catch(() => {
          self.loading = false;
        });
    },
    closeModalManageClient(client) {
      if (client) {
        this.selected_client = client;
        this.details.title = client.name;
      }
      this.isModalManageClientOpen = false;
    },
    unselectClient() {
      this.selected_client = null;
      this.details.title = null;
    },
    toggleResponsible(responsibleId) {
      this.responsibles.list = this.responsibles.list.map((person) => {
        if (person.id === responsibleId) {
          return { ...person, selected: !person.selected };
        }
        return person;
      });
    },
    saveSchedule() {
      this.loading = true;

      const form = {
        client_id: this.selected_client ? this.selected_client.id : null,
        title: this.details.title,
        priority: this.details.priority,
        status: this.details.status,
        observation: this.details.observation,
        vehicle_json: this.vehicle ? JSON.stringify({ ...this.vehicle.details, plate: this.vehicle.plate }) : null,
        forecast: this.formatDateToCreate(),
        type: 'scheduling',
        origin: 'mobile',
        responsibles: this.computedSelectedResponsibles
      };

      const promise = this.isNew ? SchedulingService.create(form) : SchedulingService.update(this.data.id, form);

      promise
        .then((response) => {
          this.$toast.success(`Compromisso ${this.isNew ? 'criado' : 'atualizado'} com sucesso`);
          this.$emit(this.isNew ? 'save' : 'edit', response.data);
        })
        .catch((error) => {
          this.$toast.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatDateToCreate() {
      const data = this.computedDateFormatted;
      const hora = this.select_hours.selected_hour;
      const minutos = this.select_hours.selected_minute;

      const partesData = data.split('/');
      const dia = parseInt(partesData[0], 10);
      const mes = parseInt(partesData[1], 10) - 1;
      const ano = parseInt(partesData[2], 10);

      const h = parseInt(hora, 10);
      const m = parseInt(minutos, 10);

      return new Date(ano, mes, dia, h, m);
    },
    closeDialog() {
      this.$emit('close');
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    uppercaseVehiclePlate() {
      this.vehicle.plate = this.vehicle.plate.toUpperCase();
    },
    getAddressData(addressData) {
      this.address = addressData;
    },
    async extractVehicleDetails(vehiclePlate) {
      this.vehicle.requested_details = true;
      this.vehicle.loading_details = true;

      try {
        const { data } = await this.$http.get(`/v2/vehicle/plate/${vehiclePlate}/data`);
        this.vehicle.details = data.vehicle;
      } catch {
        this.$toast.error('Erro ao buscar dados do veículo');
      } finally {
        this.vehicle.loading_details = false;
      }
    }
  },
  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
    },
    'vehicle.plate': function (plate) {
      if (plate === null || plate.length === 6 || plate.length === 0) {
        this.vehicle.requested_details = false;
        this.vehicle.details = null;
      }
    },
    data(newValue) {
      this.stepper = 1;

      this.compromise = newValue;

      this.responsibles.list.forEach((person) => {
        person.selected = false;
      });

      if (this.compromise.appointment_responsibles) {
        this.compromise.appointment_responsibles.forEach((responsible) => {
          const person = this.responsibles.list.find((person) => person.id === responsible.user_id);
          if (person) {
            person.selected = true;
          }
        });
      }

      const forecast = this.compromise?.forecast ? new Date(this.compromise.forecast) : null;

      if (forecast) {
        const year = forecast.getFullYear();
        const month = forecast.getMonth() + 1;
        const day = forecast.getDate();
        const fixedDate = new Date(year, month - 1, day);
        const isoDate = new Date(fixedDate.getTime() - fixedDate.getTimezoneOffset() * 60000).toISOString().substr(0, 10);
        this.date = isoDate;
        this.dateFormatted = this.formatDate(isoDate);
      }

      this.select_hours.selected_hour = forecast.getHours().toString().padStart(2, '0');
      this.select_hours.selected_minute = forecast.getMinutes().toString().padStart(2, '0');

      this.details = {
        title: this.compromise.title,
        observation: this.compromise.observation,
        priority: this.compromise.priority ?? 'little_urgent',
        status: this.compromise.status ?? 'created'
      };

      this.selected_client = this.compromise.client;

      const vehicleJson = this.compromise?.vehicle_json ?? '{"plate": null}';
      const vehicleJsonObj = typeof vehicleJson === 'string' ? JSON.parse(vehicleJson) : vehicleJson;
      const { plate } = vehicleJsonObj;

      if (plate) {
        this.vehicle.plate = plate;
        this.vehicle.details = vehicleJsonObj;
        this.vehicle.requested_details = true;
      } else {
        this.vehicle.plate = null;
        this.vehicle.details = null;
      }
    }
  }
};
</script>

<style lang="scss">
.schedule-dialog-compromise {
  .v-picker__body {
    background-color: #eee;
  }

  .select-responsible {
    overflow: hidden;
    margin-bottom: 10px;
    border-bottom-right-radius: 23px;
    border-top-right-radius: 23px;

    .sr-check {
      float: left;
      padding: 10px;
      background-color: #e3e3e3;
      width: 44px;
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;
    }

    .sr-title {
      float: left;
      padding: 10px;
      width: calc(100% - 50px);
      white-space: nowrap;
      text-overflow: ellipsis;
      background-color: #eee;
      overflow: hidden;
    }
  }

  .selected-client {
    padding: 10px;
    margin-top: 10px;
    border-radius: 6px;
    border: 2px solid #eee;

    .v-icon {
      float: right;
    }
  }

  .yeep-table {
    width: 100%;
    border: 2px solid #bebebe;
    font-size: 14px;
    border-radius: 5px;
    text-transform: uppercase;

    &.normal-text {
      text-transform: none;
    }

    tr {
      text-align: center;

      td {
        border: 1px solid #d9d9d9;
        padding: 5px 4px;
        border-radius: 5px;

        &.text-left {
          text-align: left !important;
        }
      }
    }
  }

  .close {
    background-color: #dbdbdb;
    border-radius: 50%;
    padding: 3px 7px 2px 7px;
    position: absolute;
    margin-right: 15px;
    right: 0px;
  }

  .vehicle-card {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    overflow: hidden;
    background-color: #fff;
  }

  .vehicle-card-title {
    text-align: center;
    font-weight: 600;
    font-size: 14px;
    padding: 10px;
    border-bottom: 1px solid #e0e0e0;
    color: #333;
  }

  .vehicle-card-plate {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px;
    border-bottom: 1px solid #e0e0e0;
    background-color: #f9f9f9;

    img {
      max-height: 60px;
      object-fit: contain;
    }

    span {
      font-size: 18px;
      font-weight: bold;
      color: #333;
    }
  }

  .vehicle-card-brand-row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 10px;
    border-bottom: 1px solid #e0e0e0;

    b {
      font-size: 14px;
    }
  }

  .vehicle-card-brand-logo {
    width: 70px;
    height: 70px;
    object-fit: contain;
  }

  .vehicle-card-row {
    display: flex;
    border-bottom: 1px solid #e0e0e0;
    font-size: 13px;
    color: #555;

    &:last-child {
      border-bottom: none;
    }
  }

  .vehicle-card-cell {
    flex: 1;
    padding: 8px 12px;

    &:first-child {
      border-right: 1px solid #e0e0e0;
    }
  }

  .vehicle-card-row-full {
    padding: 8px 12px;
    text-align: center;
  }
}

.v-stepper__label {
  line-height: 19px !important;
  padding-top: 5px !important;
}

.v-application--is-ltr .v-stepper--vertical .v-stepper__content {
  padding: 8px 60px 8px 23px !important;
}
</style>
